import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroller';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import fetchTicketActivity from 'actions/tickets/fetch-activity';
import AppBar from 'components/app-bar/app-bar';
import Section from 'components/content/section';
import TicketCard from 'components/tickets/ticket';

import OfficeHoursMenu from '../menu/office-hours-menu';

export default function ActivityPage() {
  const dispatch = useDispatch();
  const params = useParams();
  const courseId = Number(params.courseId);
  const [page, setPage] = useState(0);
  const [tickets, setTickets] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const loadMore = useCallback(() => {
    dispatch(fetchTicketActivity(courseId, page)).then(({ status, data }) => {
      if (status === 200 && data.tickets.length > 0) {
        setTickets((tickets) => combine([...tickets, ...data.tickets]));
        setPage((p) => p + 1);
      } else {
        setHasMore(false);
      }
    });
  }, [dispatch, courseId, page]);

  useEffect(() => {
    setPage(0);
    setTickets([]);
    setHasMore(true);
  }, [courseId]);

  useEffect(() => {
    if (page === 0 && tickets.length === 0 && hasMore) {
      loadMore();
    }
  }, [page, tickets.length, loadMore, hasMore]);

  return (
    <AppBar
      title="Latest activity"
      menu={<OfficeHoursMenu courseId={courseId} />}
    >
      <Box p={2}>
        <Paper>
          <Box p={2}>
            <Section title="Latest activity">
              <InfiniteScroll
                hasMore={hasMore}
                initialLoad={false}
                loadMore={loadMore}
              >
                {tickets.map((ticket) => (
                  <TicketCard key={ticket.id} ticket={ticket} />
                ))}
              </InfiniteScroll>

              {tickets.length === 0 && (
                <Typography paragraph>
                  There have been no recent office hours interactions.
                </Typography>
              )}
            </Section>
          </Box>
        </Paper>
      </Box>
    </AppBar>
  );
}

function combine(tickets) {
  return Object.values(
    tickets.reduce((o, t) => ({ ...o, [t.id]: t }), {})
  ).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
}
